<template>
  <div>
    <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    <c-dialog
      v-model="isShow"
      :option="option"
      @close="isShow = false"
      @confirm="submit"
    >
      <template slot="body">
        <div :class="getCss('modal-pc')">
          <div :class="getCss('list-pc')">
            <li :class="getCss('list-item-pc')">
              <span
                :style="inputTextColorStyle"
                :class="getCss('list-item-label-pc')"
                >联系人</span
              >
              <input
                type="text"
                v-model="name"
                :class="getCss('list-item-input-pc')"
                :style="inputStyle"
                placeholder="请输入你的名字"
              />
            </li>
            <li :class="getCss('list-item-pc')">
              <span
                :style="inputTextColorStyle"
                :class="getCss('list-item-label-pc')"
                >手机号码</span
              >
              <input
                type="text"
                v-model="phoneNum"
                :class="getCss('list-item-input-pc')"
                :style="inputStyle"
                placeholder="请输入手机号码"
              />
            </li>
            <li v-show="isShowEmail" :class="getCss('list-item-pc')">
              <span
                :style="inputTextColorStyle"
                :class="getCss('list-item-label-pc')"
                >电子邮箱</span
              >
              <input
                type="text"
                v-model="email"
                :class="getCss('list-item-input-pc')"
                :style="inputStyle"
                placeholder="请输入电子邮箱"
              />
            </li>
            <li :class="getCss('list-item-pc')">
              <span
                :style="inputTextColorStyle"
                :class="getCss('list-item-label-pc')"
                >详细地址</span
              >
              <textarea
                v-model="address"
                :class="getCss(['list-item-input-pc', 'list-item-textarea-pc'])"
                :style="inputStyle"
                placeholder="请输入详细地址（省、市、区、详细楼栋）"
              ></textarea>
            </li>
          </div>
        </div>
      </template>
    </c-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
// import { componentBaseMixin } from '../../../../ceiba-base-components';
// import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
// import CDialog from '../../../../ceiba-base-components/src/components/base-dialog';
import CDialog from '@tencent/ceiba-base-components/src/components/ceiba-dialog';
// import CDialog from '.././../../../ceiba-base-components/src/components/ceiba-dialog';
import button from '@tencent/ceiba-act-public-button';

export default {
  name: 'CPopupAddress',
  components: {
    // [CDialog.name]: CDialog,
    [CDialog.name]: CDialog,
    [button.name]: button,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'popup-address-',
      isShow: false,
      address: '', // 地址
      phoneNum: '', // 手机号码
      name: '', // 姓名
      email: '', // 邮箱
      provinceMarketZoneCountyShow: false,
      provinceMarketZoneCounty: '', // 选中地方
    };
  },
  computed: {
    option() {
      let closeStyle = this.dialogConfig?.closeStyle || {};
      const bgImageReg = /^url\((https:|http:)?\/\/[^\s]*\)$/;
      if (
        !closeStyle.backgroundImage
        || !bgImageReg.test(closeStyle.backgroundImage)
      ) {
        closeStyle = '';
      }
      let confirmIconStyle = '';
      const { confirmIcon = '' } = this.configurationData;
      const { backgroundImage = '' } = this.dialogConfig?.confirmStyle || {};
      if (confirmIcon) {
        confirmIconStyle = `url(${confirmIcon})`;
      }
      if (!confirmIconStyle && bgImageReg.test(backgroundImage)) {
        confirmIconStyle = backgroundImage;
      }

      // 弹框尺寸
      const { popStyle = {} } = this.styles;
      const { width = '', height = '' } = popStyle;
      console.log('address 填写地址弹框 width =', width, 'height =', height);

      return Object.assign({}, this.dialogConfig, {
        header: '填写地址',
        footer: true,
        confirm: '提交',
        confirmStyle: {},
        height: 'auto',
        width: '500px',
        closeLocation: 'top-right',
        close: true,
        isConfirmClose: false,
        maskClickable: false,
        closeStyle: { backgroundImage: 'url(https://act.supercore.qq.com/activity/supercore/14161/be052f80d9bba6a5888eb12b6b045ffa.png)' },
        dialogStyle: Object.assign({}, this.dialogConfig?.dialogStyle || {}, {
          backgroundImage: this.configurationData.backgroundImage
            ? `url(${this.configurationData.backgroundImage})`
            : this.dialogConfig?.dialogStyle?.backgroundImage,
          color: this.configurationData?.inputTextColor || '#3e3e3e',
        }),
      });
    },
    inputTrips() {
      return (
        this.configurationData.trips
        || '为保证正常发货，请正确填写手机号及收货地址'
      );
    },
    computedStyle() {
      return {
        backgroundImage: this.configurationData.btnImage
          ? `url(${this.configurationData.btnImage})`
          : 'none',
      };
    },
    inputStyle() {
      console.log(
        'this.option.dialogStyle.color=',
        this.option?.dialogStyle?.color,
      );

      return {
        borderRadius: '6px',
        color: this.configurationData?.inputTextColor || '#3e3e3e',
        borderColor: this.configurationData?.inputTextColor || '#3e3e3e',
        background: this.configurationData.inputBackgroundColor || '#ffffff',
      };
    },
    inputTextColorStyle() {
      return {
        color: this.configurationData?.inputTextColor || '#3e3e3e',
      };
    },
    // 是否开启邮箱填写
    isShowEmail() {
      return this.configurationData.isShowEmail || false;
    },
    // 查询地址机制： joinPageQueryAddress：进入页面查询；clickQueryAddress：点击查询
    queryAddressMechanism() {
      return (
        this.configurationData.queryAddressMechanism || 'joinPageQueryAddress'
      );
    },
  },
  mounted() {
    console.log(
      'version:1.0.18 configurationData===========popaddress=',
      this.configurationData,
    );
    // if (!this.configurationData.bindFlowID || !this.configurationData.checkFlowID) {
    //   return false;
    // }
    this.initialize();
  },
  methods: {
    initialize() {
      this.$refs.button.setClickHandler(this.showDialog, {
        forceApp: !!this.configurationData.forceApp,
        forceLogin: true,
        forceRole: !!this.configurationData.forceRole,
      });

      const self = this;
      // 监听user.ready
      this.$onLogined(async () => {
        // 进入页面查询地址
        if (this.queryAddressMechanism === 'joinPageQueryAddress') {
          self.check();
        }
      });

      // 监听package.address.fill
      this.$eventBus.$on('ceiba:common:events:address-fill', () => {
        self.showDialog();
      });
    },
    async showDialog() {
      console.log('this.isShow=true');
      // 点击后查询地址
      if (this.queryAddressMechanism === 'clickQueryAddress') {
        await this.check();
      }
      this.isShow = true;
      this.reportClick({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
      });
    },
    closeDialog() {
      this.isShow = false;
    },
    async check() {
      console.log(
        'this.configurationData.checkFlowID=',
        this.configurationData,
        this.configurationData.checkFlowID,
      );
      const response = await this.flowRequest({
        flowId: this.configurationData.checkFlowID,
      });
      const { ret, msg, data } = response;
      if (ret !== 0) {
        this.alert(msg);
        return false;
      }
      data.ret = parseInt(data.ret, 10);
      if (data.ret === 0) {
        (this.provinceMarketZoneCounty = data?.addr?.Address?.substring(
          0,
          data?.addr?.Address?.indexOf('|'),
        )) || '', // 默认展示选中的城市内容
        (this.address = data?.addr?.Address?.substring(data?.addr?.Address?.indexOf('|') + 1)), // 精确地址
        (this.phoneNum = data?.addr?.Phone),
        (this.name = data?.addr?.Name),
        (this.email = data?.addr?.Email);
      } else {
        this.alert('查询绑定地址失败:', response.msg);
      }
    },
    async submit() {
      const addressSplicing = `${this.provinceMarketZoneCounty}|${this.address}`;
      console.log(
        'phoneNum=',
        this.phoneNum,
        'address=',
        addressSplicing,
        'name=',
        this.name,
      );
      if (!this.address) {
        this.alert('请正确输入地址');
        return false;
      }
      if (!this.name) {
        this.alert('请正确输入姓名');
        return false;
      }
      if (!this.phoneNum) {
        this.alert('手机号码不能为空');
        return false;
      }
      if (isNaN(this.phoneNum) || this.phoneNum.indexOf('.') >= 0) {
        this.alert('手机号码必须为数字。');
        return false;
      }
      if (this.phoneNum.length !== 11) {
        this.alert('手机号码长度不正确');
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(this.phoneNum)) {
        this.alert('请填写正确的手机号码。');
        return false;
      }
      if (this.isShowEmail && !this.email) {
        this.alert('请正确输入邮箱');
        return false;
      }
      const params = JSON.stringify({
        address: addressSplicing,
        phoneNum: this.phoneNum,
        name: this.name,
        email: this.email,
      });
      console.log('bind params=', params);
      const response = await this.flowRequest({
        flowId: this.configurationData.bindFlowID,
        params: {
          data: params,
        },
      });
      const { data } = response;
      data.ret = parseInt(data.ret, 10);
      if (data.ret === 0) {
        this.alert('提交成功');
        this.closeDialog();
        this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'bind_address',
          eventData: {
            status: '1',
          },
        });
      } else {
        this.alert(response.msg);
        this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'bind_address',
          eventData: {
            status: '0',
          },
        });
      }
    },
    selectAreaShowHandler() {
      this.provinceMarketZoneCountyShow = true;
    },
    selectConfirm(data) {
      console.log('selectData=', data);
      this.provinceMarketZoneCountyShow = false;
      this.provinceMarketZoneCounty = `${data[0]?.name || ''}${
        data[1]?.name ? '/' : ''
      }${data[1]?.name || ''}${data[2]?.name ? '/' : ''}${data[2]?.name || ''}`;
    },
  },
};
</script>
  <style lang="scss">
@import './popup-address-dialog-pc.scss';
</style>

